import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import BackgroundFX from "@/components/site/BackgroundFX";
import Contact from "@/components/site/Contact";

export const ContactPage = () => {
  return (
    <main className="relative bg-[#F7F6F3] text-[#1A1A1A] overflow-x-hidden">
      <BackgroundFX />
      <div className="relative z-10">
        <Navbar />
        <div className="pt-24" />
        <Contact />
        <Footer />
      </div>
    </main>
  );
};

export default ContactPage;
